/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A4Inputs */

const en_to_xml_faq_a4 = /** @type {(inputs: To_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently, the root element is named 'root' by default. You can rename it in the output after copying.`)
};

const ko_to_xml_faq_a4 = /** @type {(inputs: To_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 루트 요소는 기본적으로 'root'로 이름이 지정됩니다. 복사 후 출력에서 이름을 변경할 수 있습니다.`)
};

const ja_to_xml_faq_a4 = /** @type {(inputs: To_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在、ルート要素はデフォルトで「root」という名前です。コピー後に出力内で名前を変更できます。`)
};

/**
* | output |
* | --- |
* | "Currently, the root element is named 'root' by default. You can rename it in the output after copying." |
*
* @param {To_Xml_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a4 = /** @type {((inputs?: To_Xml_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a4(inputs)
	if (locale === "ko") return ko_to_xml_faq_a4(inputs)
	return ja_to_xml_faq_a4(inputs)
});